import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewsTable',
  props: {
    columns: null,
    dataSource: null,
    selectedRowKeys: null
  },
  emits: ["onRowClick", "update:selectedRowKeys"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'onRowClick', record: Record<string, any>): void;
    (e: 'update:selectedRowKeys', keys: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    columns: Array<{ title: string; dataIndex: string; key: string; type?: string }>;
    dataSource: Array<Record<string, any>>;
    selectedRowKeys: string[];
};





const booleanColumns = computed(() => props.columns.filter((col) => col.type === 'boolean'));

const processedColumns = computed(() =>
    props.columns.map((col) => ({
        ...col,
        scopedSlots: col.type === 'boolean' ? { customRender: col.dataIndex } : undefined,
    })),
);

// Row selection config
const rowSelection = computed(() => ({
    selectedRowKeys: props.selectedRowKeys,
    onChange: (keys: string[]) => {
        emit('update:selectedRowKeys', keys);
    },
}));

function customRow(record: any) {
    return {
        on: {
            click: () => emit('onRowClick', record),
        },
        style: {
            cursor: 'pointer',
        },
    };
}

return { __sfc: true,props, emit, booleanColumns, processedColumns, rowSelection, customRow }
}

})